// providers/casePeer.ts
import * as Api from '@ViewModels';
import { ATTORNEY_TAG_OPTIONS } from './constants';
import { provider, providerTag, select } from './helpers';

export const casePeerConfig = provider(Api.IntegrationProvider.CasePeer, {
	displayName: 'CasePeer',

	main: {
		writebacks: false,
	},

	showKeyFacts: false,

	tags: {
		coreTags: true,
		providerTags: [
			providerTag('CourtCaseNumber', 'Court Case Number'),
			providerTag('CourtCaseName', 'Court Case Name'),
			providerTag('CaseName', 'Case Name'),
			providerTag('CaseType', 'Case Type'),
		],
		extraFields: [
			select('leadAttorneyTag', ATTORNEY_TAG_OPTIONS, {
				label: 'Lead Attorney Tag Options',
				subtitle: 'Control how lead attorney information is tagged on contacts',
				placeholder: 'Select lead attorney tag options',
			}),
			select('caseManagerTag', ATTORNEY_TAG_OPTIONS, {
				label: 'Case Manager Tag Options',
				subtitle: 'Control how case manager information is tagged on contacts',
				placeholder: 'Select case manager tag options',
			}),
		],
	},
});
